import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_PART_NUMBER_DETAILS } from './url-constants';

type GetPartNumberEndpointSpecification = ApiEndpointSpecification;
export const GetPartNumberEndpointSpecification: GetPartNumberEndpointSpecification = {
    url: GET_PART_NUMBER_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetPartNumberRequestParams',
    requestBodySchemaName: 'GetPartNumberRequestBody',
    okResponseSchemaName: 'GetPartNumberOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2,
};

export const invokeGetPartNumberDetails = Helpers.makeApiRequestFn<
    Types.GetPartNumberRequestParams,
    Types.GetPartNumberRequestBody,
    Types.GetPartNumberOkResponse
>(GetPartNumberEndpointSpecification);
